import React from "react";
import "./Experience.css";
import CustomButton from "./Custombtn";
function Experience({role,type,year,place,description,imglink,href}) {
  return (
    <div className="exp-card">
      <div className="card-inner">
        <div className="card-front" style={{ backgroundImage: `url(${imglink})` }}>
          <h2>{role}</h2>
          <p>{type}</p>
        </div>
        <div className="card-back">
          <div className="back-img">
          <img src={imglink} />
          </div>
          <h1>
            {role}<span>{type}</span>
          </h1>
          <p>{year}</p>
          <p>{place}</p>
          <p>
            {description}
          </p>
          <div className="view-morebtn">
          <CustomButton btntitle="View-more" href={href}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experience;
